module.exports = __webpack_public_path__ + "img/theodore-alexander-mobile.5efbbba.jpeg";